function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#report_posts_svg__clip0_2981_3963)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 16.5a16 16 0 0116-16h48a16 16 0 0116 16v48a16 16 0 01-16 16H16a16 16 0 01-16-16v-48z",
  fill: "#E5F7F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.76 29.282L45.534 19.06a1.282 1.282 0 00-.906-.376H26.731a1.28 1.28 0 00-1.278 1.28V61.04a1.28 1.28 0 001.28 1.278h28.124a1.28 1.28 0 001.28-1.28V30.192c-.008-.036.018-.514-.378-.908v-.002zm-9.85-6.236l5.86 5.862h-4.583a1.28 1.28 0 01-1.28-1.278l.002-4.584zm-17.9 36.716V21.238H43.35v6.392a3.84 3.84 0 003.836 3.836h6.392V59.76H28.011l-.002.002z",
  fill: "#1E6B71"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.128 39.22a1.281 1.281 0 100-2.556 1.28 1.28 0 000 2.556zm15.34-2.556H38.242a1.28 1.28 0 000 2.558H48.47a1.28 1.28 0 00-.002-2.558zm-15.34 7.672a1.28 1.28 0 10.101-2.558 1.28 1.28 0 00-.101 2.558zm15.34-2.556H38.242a1.28 1.28 0 000 2.556H48.47a1.28 1.28 0 000-2.558l-.002.002zm-15.34 7.668a1.281 1.281 0 10.143-2.558 1.281 1.281 0 00-.143 2.558zm15.34-2.556H38.242a1.28 1.28 0 000 2.556H48.47a1.28 1.28 0 00-.002-2.556zm-15.34 7.67a1.281 1.281 0 10.143-2.558 1.281 1.281 0 00-.143 2.558zm15.34-2.556H38.242a1.28 1.28 0 000 2.556H48.47a1.28 1.28 0 00-.002-2.556z",
  fill: "#1E6B71"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "report_posts_svg__clip0_2981_3963"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .5)",
  d: "M0 0h80v80H0z"
})));

var SvgReportPosts = function SvgReportPosts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 80 81",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgReportPosts;